import React from "react";
import {
  Grid,
  Box,
  Container,
  useMediaQuery,
  styled,
  Stack,
  Theme,
} from "@mui/material";
import BannerContent from "./BannerContent";
// import bannerbgImg1 from "../../../assets/images/landingpage/bannerimg1.svg";
// import bannerbgImg2 from "../../../assets/images/landingpage/bannerimg2.svg";
// import bannerPrueba from "../../../assets/images/landingpage/1.svg"
// import bannerPrueba2 from "../../../assets/images/landingpage/4.svg"
// import bannerPrueba3 from "../../../assets/images/landingpage/5.svg"
// import bannerPrueba4 from "../../../assets/images/landingpage/6.svg"
import Image from "../../../utils/Image";


const Banner = () => {
  const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("lg"));

  const SliderBox = styled(Box)(() => ({
    "@keyframes slideup": {
      "0%": {
        transform: "translate3d(0, 0, 0)",
      },
      "100% ": {
        transform: "translate3d(0px, -100%, 0px)",
      },
    },

    animation: "slideup 35s linear infinite",
  }));

  const SliderBox2 = styled(Box)(() => ({
    "@keyframes slideDown": {
      "0%": {
        transform: "translate3d(0, -100%, 0)",
      },
      "100% ": {
        transform: "translate3d(0px, 0, 0px)",
      },
    },

    animation: "slideDown 35s linear infinite",
  }));

  return (
    <Box mb={10} sx={{ overflow: "hidden" }}>
      <Container maxWidth="lg">
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={12} lg={6} sm={8}>
            <BannerContent />
          </Grid>
          {lgUp ? (
            <Grid item xs={12} lg={6}>
              <Box
                p={3.2}
                sx={{
                  backgroundColor: (theme) => theme.palette.primary.light,
                  minWidth: "2000px",
                  height: "calc(100vh - 100px)",
                  maxHeight: "790px",
                }}
              >
                <Stack direction={"row"} spacing={1.5}>
                  <Box>
                    <SliderBox>
                      <Image src={'https://familygeeks.com/members/wp-content/uploads/2023/08/1.svg'} alt="banner" width="403" height="810" />
                    </SliderBox>
                    <SliderBox>
                      <Image src={'https://familygeeks.com/members/wp-content/uploads/2023/08/2.svg'} alt="banner" width="403" height="810" />
                    </SliderBox>
                  </Box>
                  <Box>
                    <SliderBox2>
                      <Image src={'https://familygeeks.com/members/wp-content/uploads/2023/08/3.svg'} alt="banner" width="403" height="810"  />
                    </SliderBox2>
                    <SliderBox2>
                      <Image src={'https://familygeeks.com/members/wp-content/uploads/2023/08/4.svg'} alt="banner" width="403" height="810" />
                    </SliderBox2>
                  </Box>
                </Stack>
              </Box>
            </Grid>
          ) : null}
        </Grid>
      </Container>
    </Box>
  );
};

export default Banner;
